import leg from './leg';

export default function() {
	return {
		...leg(),

		duration: undefined, // eta - etd days
		departureTime: undefined, // etd time
		arrivalTime: undefined,	// eta time

		fromAddressId: null,
		toAddressId: null,
		vendorId: null,
		driverId: null,
		cargoCarrierId: null,
	};
}
